import React from 'react';
import { Link } from 'react-router-dom';

const WhatAreWeToDoWith = ({ cursorVisibility }) => {
  return (
    <Link id={cursorVisibility} className="What-are-we-to-do-with link none" to="/">
      <div>
        <div>
          What are we to do with these brisk young men who break through all fences and, in every house, make themselves at home?<br />
          What they want is <i>extempore Sing-Sing,</i> not candy. One such arrived at the party, at first unnoticed. He advanced to his own music and soon began in melody:
        </div>
        <br />
        <br />
        <div className="centered-italic">
          <i>
            How will this end?<br />
            How will this end?
          </i>
        </div>
        <br />
        <br />
        <div>
          All ears, I removed my hat and placed it on the seat beside me. I listened closely to this couraegous outpour of emotion and intelligence.<br />
          I could have felt the truth of his sentences—the build, shall I say, of some overgrown member. Instead I felt the urge to open the window a little.
        </div>
        <div>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
        <div>
          On my walk home I was very responsible. Like a well-weaned subject, I gathered up the mirages of a fact.<br />
          I knew then that I must see the world. I would travel like a sovereign: <i>incognito</i>.
        </div>
      </div>
    </Link >
  );
};

export default WhatAreWeToDoWith;
